import React from "react";
import SineWaves from "sine-waves";
import VisibilitySensor from "react-visibility-sensor";
import Button from "../../_components/button/Button";
const SoundWaveMobile = () => {
  const [isVisible, setIsVisible] = React.useState(true);

  const [leftWaves, setLeftWaves] = React.useState(false);
  const [rightWaves, setRightWaves] = React.useState(false);
  React.useEffect(() => {
    if (isVisible) {
      let waves = new SineWaves({
        el: document.getElementById("leftWavesMobile"),
        speed: 7,
        ease: "SineInOut",
        wavesWidth: "100%",
        // width: changedWidth,
        width: 200,
        height: 400,

        waves: [
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: -50,
            wavelength: 25,
          },
          {
            timeModifier: 2,
            lineWidth: 3,
            amplitude: -70,
            wavelength: 30,
          },
          {
            timeModifier: 4,
            lineWidth: 2,
            amplitude: -120,
            wavelength: 30,
          },
          {
            timeModifier: 3,
            lineWidth: 3,
            amplitude: 140,
            wavelength: 40,
          },
          {
            timeModifier: 0.5,
            lineWidth: 3,
            amplitude: -60,
            wavelength: 60,
          },
          //   {
          //     timeModifier: 1.3,
          //     lineWidth: 3,
          //     amplitude: -40,
          //     wavelength: 40,
          //   },
          //   {
          //     timeModifier: 3,
          //     lineWidth: 3,
          //     amplitude: 110,
          //     wavelength: 35,
          //   },
          //   {
          //     timeModifier: 3.5,
          //     lineWidth: 2,
          //     amplitude: 80,
          //     wavelength: 60,
          //   },
          //   {
          //     timeModifier: 2.5,
          //     lineWidth: 3,
          //     amplitude: 139,
          //     wavelength: 45,
          //   },
        ],

        resizeEvent: function () {
          var gradient = this.ctx.createLinearGradient(0, 0, this.width, 0);
          gradient.addColorStop(0, "rgba(25, 255, 255, 0)");
          gradient.addColorStop(0.5, "rgba(255, 25, 255, 0.75)");
          gradient.addColorStop(1, "rgba(255, 255, 25, 0");

          var index = -1;
          var length = this.waves.length;
          while (++index < length) {
            this.waves[index].strokeStyle = gradient;
          }

          index = void 0;
          length = void 0;
          gradient = void 0;
        },
      });
      setLeftWaves(waves);
    } else {
      if (leftWaves) {
        leftWaves.running = false;
      }
    }
  }, [isVisible]);
  React.useEffect(() => {
    let waves = new SineWaves({
      el: document.getElementById("rightWavesMobile"),

      speed: 4,

      ease: "SineInOut",

      wavesWidth: "100%",
      // width: changedWidthRight,
      width: 200,

      height: 400,

      waves: [
        // {
        //   timeModifier: 4,
        //   lineWidth: 2,
        //   amplitude: 90,
        //   wavelength: 25,
        // },
        // {
        //   timeModifier: 4,
        //   lineWidth: 2,
        //   amplitude: 100,
        //   wavelength: 30,
        // },
        {
          timeModifier: 4,
          lineWidth: 2,
          amplitude: 65,
          wavelength: 35,
        },
        {
          timeModifier: 4,
          lineWidth: 2,
          amplitude: 70,
          wavelength: 40,
        },
        {
          timeModifier: 4,
          lineWidth: 2,
          amplitude: 80,
          wavelength: 45,
        },
        {
          timeModifier: 4,
          lineWidth: 2,
          amplitude: 75,
          wavelength: 50,
        },
      ],

      resizeEvent: function () {
        var gradient = this.ctx.createLinearGradient(0, 0, this.width, 0);
        gradient.addColorStop(1, "rgba(255, 255, 25, 0");
        gradient.addColorStop(0.5, "rgba(255, 25, 255, 0.75)");
        gradient.addColorStop(0, "rgba(25, 255, 255, 0)");

        var index = -1;
        var length = this.waves.length;
        while (++index < length) {
          this.waves[index].strokeStyle = gradient;
        }

        // Clean Up
        index = void 0;
        length = void 0;
        gradient = void 0;
      },
    });
    setRightWaves(waves);
  }, [isVisible]);

  const handleClick = () => {
    window.open(
      "https://www.anthemarc.com/index.php?utm_source=AnthemAV.com&utm_medium=Online&utm_campaign=Anthem%20Room%20Correction&utm_content=Redirect",
      "_blank"
    );
  };

  function onChange(isVisible) {
    setIsVisible(isVisible);
  }
  return (
    <section className="z-50 relative bg-black h-full lg:hidden md:hidden py-16 ">
      {/* <VisibilitySensor
        onChange={onChange}
        // offset={{
        //   top: 500,
        // }}
        // delayedCall
        partialVisibility
        minTopValue={100}
      > */}
      {/* <div className="max-w-screen-2xl flex md:flex w-full items-center mt-10 m-auto ">
          <div className="w-1/5 md:w-1/5 z-50" id="waves-left-container">
            <canvas className="w-full" id="leftWavesMobile"></canvas>
          </div>
          <div className="w-3/5  md:w-3/5">
            <img
              className="w-full scale-110"
              src="https://cdn.pmlsound.com/anthem/avm90/images/avm90-arc-gradient-unit-591x1219.png"
            />
          </div>
          <div className="w-1/5 md:w-1/5" id="waves-right-container">
            <canvas className="w-full" id="rightWavesMobile"></canvas>
          </div>
        </div> */}
      <div
        // style={{
        //   backgroundImage:
        //     "url(" +
        //     "https://cdn.pmlsound.com/anthem/avm90/images/waves-mobile.jpg" +
        //     ")",
        // }}
        className=" bg-no-repeat bg-cover bg-black"
      >
        <div className="max-w-7xl mx-auto px-10">
          <div className="lg:flex lg:space-x-7">
            <h4 className="lg:w-2/5 text-4xl md:text-5xl lg:text-left text-center lg:text-6xl font-bold  text-white leading-snug z-50">
              The power to engineer your room
            </h4>

            <p className="lg:w-3/5 text-xl lg:text-left text-center font-light  text-white lg:mt-0 mt-10">
              At Anthem, we like to take things one step further. Rather than
              just designing a processor, we want to engineer your room. With
              the most advanced implementation of our award-winning ARC: Genesis
              room correction, professional calibration of your system can be
              achieved with the click of a button while still offering advanced
              functionality to refine the sound to your personal taste.
            </p>
          </div>
        </div>
        <div class="flex items-center justify-center mt-32 ">
          <div class="flex items-center h-24 text-white">
            <div className=" w-7/12 flex flex-col" id="waves-left-container">
              <canvas className="w-full" id="leftWavesMobile"></canvas>
            </div>
            <div className="flex flex-col w-3/4">
              <img
                class="h-full z-50"
                src="https://cdn.pmlsound.com/anthem/avm90/images/avm90-arc-gradient-unit-left.png"
                width="100%"
                height="100%"
              ></img>
            </div>
          </div>
        </div>
        <div
          className="max-w-7xl mx-auto mt-12 px-10 bg-no-repeat bg-cover bg-black"
          style={{
            backgroundImage:
              "url(" +
              "https://cdn.pmlsound.com/anthem/avm90/images/waves-mobile-section-1-blur.jpg" +
              ")",
          }}
        >
          <div className="lg:flex lg:space-x-7 mb-10">
            <p className="lg:w-3/5 text-xl lg:text-left text-center font-light  text-white lg:mt-0 mt-10">
              Surfaces such as windows, furnishings, and the geometry of the
              walls, floor, and ceiling add unwanted resonance and coloration.
            </p>
          </div>
        </div>

        <div class="flex items-center justify-center mt-12 mb-16">
          <div class="flex items-center  h-24 text-white">
            <div className="flex flex-col w-76">
              <img
                class="h-full py-2"
                src="https://cdn.pmlsound.com/anthem/avm90/images/avm90-arc-gradient-unit-right.png"
                width="100%"
                height="100%"
              ></img>
            </div>
            <div className="w-7/12 flex flex-col " id="waves-left-container">
              <canvas className="w-full" id="rightWavesMobile"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div
        className="max-w-7xl mx-auto mt-10 px-10 bg-no-repeat bg-cover bg-black"
        style={{
          backgroundImage:
            "url(" +
            "https://cdn.pmlsound.com/anthem/avm90/images/waves-mobile-section-2-blur.jpg" +
            ")",
        }}
      >
        <div className="lg:flex lg:space-x-7 mb-10 ">
          {/* <p className="lg:w-3/5 text-xl lg:text-left text-center font-light  text-white lg:mt-0 mt-10">
            Surfaces such as windows and furnishings and the geometry of the
            walls, floor, and ceiling add unwanted resonance and coloration,
            making the bass either boomy or less punchy, voices less natural,
            and the dialogue less intelligible.
          </p> */}

          <p className="lg:w-3/5 text-xl lg:text-left text-center  font-light  text-white lg:mt-0 mt-10 ">
            Anthem Room Correction measures each speaker's output relative to
            the listening area, then through a series of calculations, adjusts
            its output. Not only does ARC correct peaks and dips in a speaker's
            frequency response, but it also preserves the beneficial acoustic
            attributes of a room.
          </p>
        </div>
        <Button name="Learn More" handleClick={handleClick} />
      </div>
      {/* </VisibilitySensor> */}
    </section>
  );
};

export default SoundWaveMobile;
